import { createContext, useContext, useState, useCallback } from 'react';

const DemoTourContext = createContext();

export function DemoTourProvider({ children }) {
  const [active, setActive] = useState(false);
  const start = useCallback(() => setActive(true), []);
  const end = useCallback(() => setActive(false), []);
  return (
    <DemoTourContext.Provider value={{ active, start, end }}>
      {children}
    </DemoTourContext.Provider>
  );
}

export function useDemoTour() {
  return useContext(DemoTourContext);
}
